
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/projects",
      function () {
        return require("private-next-pages/admin/projects/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/projects"])
      });
    }
  